import { useEffect, useState } from "react";
import api from "../lib/api";
import { InspirationBanner } from "../components/InspirationBanner";
import { MarqueeStrip } from "../components/MarqueeStrip";
import { LandingHeader } from "../components/landing/LandingHeader";
import { HeroSection } from "../components/landing/HeroSection";
import { StatsSection } from "../components/landing/StatsSection";
import { VisionSection } from "../components/landing/VisionSection";
import { HonorSection } from "../components/landing/HonorSection";
import { ValuesSection } from "../components/landing/ValuesSection";
import { StoriesSection } from "../components/landing/StoriesSection";
import { LandingFooter } from "../components/landing/LandingFooter";

export default function Landing() {
  const [overview, setOverview] = useState(null);
  const [honor, setHonor] = useState({ secondary: [], staff: [] });
  const [stories, setStories] = useState([]);
  const [values, setValues] = useState([]);

  useEffect(() => {
    api.get("/public/overview").then((r) => setOverview(r.data)).catch(() => {});
    api.get("/public/honor").then((r) => setHonor(r.data)).catch(() => {});
    api.get("/public/stories").then((r) => setStories(r.data)).catch(() => {});
    api.get("/public/values-analytics").then((r) => setValues(r.data.values)).catch(() => {});
  }, []);

  const sc = overview?.stage_counts || {};
  const stats = [
    { label: "مدرسة ثانوية", value: sc["ثانوية"], testid: "stat-secondary" },
    { label: "مدرسة متوسطة", value: sc["متوسطة"], testid: "stat-middle" },
    { label: "مدرسة ابتدائية", value: sc["ابتدائية"], testid: "stat-elementary" },
    { label: "روضة أطفال", value: sc["روضة"], testid: "stat-kindergarten" },
    { label: "ساعة تطوعية (طلاب ومنسوبون)", value: overview?.hours, testid: "stat-hours" },
    { label: "متطوع فريد (الجميع)", value: overview?.total_volunteers, testid: "stat-volunteers" },
  ];

  return (
    <div className="min-h-screen bg-bg text-ink">
      <LandingHeader />
      <HeroSection />
      <StatsSection stats={stats} />
      <section className="max-w-6xl mx-auto px-5 pb-4">
        <InspirationBanner />
      </section>
      <VisionSection />
      <HonorSection honor={honor} />
      <MarqueeStrip />
      <ValuesSection values={values} />
      <StoriesSection stories={stories} />
      <LandingFooter />
    </div>
  );
}
